import 'aos/dist/aos.css';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import BannerImg from '../../../../public/assets/images/BannersFiles/27.jpg';
import StaticBanner from '../../../components/elements/StaticBanner';
import { PageHitCountApi } from '../../../shared/Helper';
import { useLocation } from 'react-use';
import { useState } from 'react';
import { getFromLocalStorage } from '../../../components/helper/authorizationHelper';

const Misionvision = () => {
  const isActive = useSelector((state) => state.toggle.isActive);
    const [epUserID, setEpUserID] = useState(null);
  const { t } = useTranslation();
  const { pathname } = useLocation();

  useEffect(() => {
    localStorage.setItem('isHome', true);
  }, []);


  useEffect(() => {

    const retrievedData = getFromLocalStorage('upid');
    retrievedData
      ?.then((res) => {
        setEpUserID(res);
      })
      .catch((err) => {
        console.log('data', err);
      });

const role = localStorage.getItem('role');
if (!role) {
  PageHitCountApi(pathname, 0);
}


if (role && epUserID != null && epUserID != 0) {
  PageHitCountApi(pathname, epUserID);
}
}, [epUserID]);


  return (
    <>
      <StaticBanner BannerImg={'/assets/images/BannersFiles/27.jpg'} en_US={'Vision & Mission'} arabic={false} />
      <div className=" pb-5  ">
        <section
          className={` sm:h-90 flex justify-left items-center align-middle xl:flex-row flex-col  py-1 px-8 lg:px-12 ${isActive ? 'text-right' : 'text-left'}`}
        >
          <div className="pb-4   xl:h-auto  w-full  xl:w-1/2">
            {/* <img src={`/assets/images/1234.png`} className="pb-4    md:max-w-screen-sm" alt="" /> */}
            <img src={`/assets/images/1234.png`} className="w-full h-full object-cover object-center" alt="" />
          </div>

          <div className="w-full  xl:w-1/2 ">
            <h2 className={`text-customgreen text-3xl flex font-bold py-3  `}>{t('Vision')}</h2>
            <h4 className={`text-customgreen flex sm:text-2xl items-center text-justify sm:leading-10 pt-1 `}>
              {isActive
                ? ` الرؤية: استدامة الريادة في العمل الخيري والإنساني محلياً ودولياً الرسالة: جمعية تعمل على تمكين العمل الخيري
            والإنمائي للمحسنين والمستحقين والاستجابة لتطلعاتهم واحتياجاتهم وإسعادهم من خلال مشاريع وخدمات ذات حلول مرنة
            وذكية لتعزيز جودة الحياة لأفراد المجتمعات داخل وخارج الدولة`
                : `Vision
Sustaining leadership in charity and humanitarian work locally and internationally.`}
            </h4>
            <h2 className={`text-customgreen text-3xl flex font-bold py-3  `}>{t('Mission')}</h2>
            <h4 className="text-customgreen flex sm:text-2xl items-center text-justify sm:leading-10 pt-1">
              {isActive
                ? `الرسالة: جمعية تعمل على تمكين العمل الخيري
            والإنمائي للمحسنين والمستحقين والاستجابة لتطلعاتهم واحتياجاتهم وإسعادهم من خلال مشاريع وخدمات ذات حلول مرنة
            وذكية لتعزيز جودة الحياة لأفراد المجتمعات داخل وخارج الدولة`
                : `Mission An association dedicated to enabling charitable and developmental work for benefactors and
              beneficiaries, responding to their aspirations and needs, and making them happy through flexible and smart
              solutions to enhance the quality of life for individuals within and outside the country.`}
            </h4>
          </div>
        </section>
      </div>
    </>
  );
};

export default Misionvision;
